import FontSizePlugin from './FontSizePlugin';

export default FontSizePlugin;
